// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-Scrim_cls1__k8T1T","cls2":"SplitMobileFab-Scrim_cls2__2v8mM SplitMobileFab-Scrim_cls1__k8T1T"};